export default __webpack_public_path__ + "static/media/MAC2.22731786.png";